import axios from 'axios'

import { parseRecord } from './jsonApiHelpers'

export const SKILL_STATUS_ORDER = ['unintroduced', 'introduced', 'completed']

export function getNextSkillStatus(status) {
  const currentIndex = SKILL_STATUS_ORDER.indexOf(status)
  const nextIndex = (currentIndex + 1) % SKILL_STATUS_ORDER.length
  return SKILL_STATUS_ORDER[nextIndex]
}

export async function updateStudentSkillStatus(id, status) {
  const response = await axios.patch(`/api/students_skills/${id}`, {
    studentsSkill: { status }
  })

  return parseRecord(response)
}
